module.exports = __webpack_public_path__ + "static/img/book.824c3c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/book.png
// module id = sK6Y
// module chunks = 1